<template>
  <Dropdown
    v-model="currentLocale"
    :options="locales"
    optionLabel="name"
    optionValue="code"
    class="language-selector"
    @change="changeLocale"
  >
    <template #value="slotProps">
      <div class="flex align-items-center">
        <img 
          :src="getFlagUrl(slotProps.value)" 
          :alt="slotProps.value"
          class="flag-icon mr-2"
        />
        <div class="hidden md:block">{{ getLocaleName(slotProps.value) }}</div>
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex align-items-center">
        <img 
          :src="getFlagUrl(slotProps.option.code)" 
          :alt="slotProps.option.code"
          class="flag-icon mr-2"
        />
        <div>{{ slotProps.option.name }}</div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { locale } = useI18n()
    const currentLocale = computed({
      get: () => locale.value,
      set: (value) => locale.value = value
    })

    const locales = [
      { code: 'fr', name: 'Français' },
      { code: 'en', name: 'English' },
      { code: 'ar', name: 'العربية' }
    ]

    const getLocaleName = (code) => {
      return locales.find(l => l.code === code)?.name || code
    }

    const getFlagUrl = (code) => {
      return `/flags/${code}.svg`
    }

    const changeLocale = (event) => {
      localStorage.setItem('locale', event.value)
      // Reload the page to ensure all components are properly translated
      window.location.reload()
    }

    return {
      currentLocale,
      locales,
      getLocaleName,
      getFlagUrl,
      changeLocale
    }
  }
}
</script>

<style scoped>
.language-selector {
  min-width: 4rem;
}

@media screen and (min-width: 768px) {
  .language-selector {
    min-width: 8rem;
  }
}

:deep(.p-dropdown) {
  background: transparent;
  border: none;
}

:deep(.p-dropdown:not(.p-disabled).p-focus) {
  box-shadow: none;
  border-color: transparent;
}

:deep(.p-dropdown:not(.p-disabled):hover) {
  border-color: transparent;
}

:deep(.p-dropdown-panel) {
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.flag-icon {
  width: 18px;
  height: 18px;
  object-fit: cover;
}
</style>
